import ApplicantItem from './ApplicantItem'

export default ApplicantItem
